<template>
    <div>
        <div class="modal modal-fx-fadeInScale" v-bind:class="{ 'is-active': showModal }">
            <div class="modal-background" @click="close"></div>
            <div class="modal-card" :class="{ 'is-fullwidth': isFullWidth }">
                <header class="modal-card-head" :class="theme">
                    <p class="modal-card-title">{{ title }}</p>
                    <button class="delete" aria-label="hasSeenNotice" @click="close"></button>
                </header>

                <section class="modal-card-body">
                    <slot>Loading content...</slot>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" :class="[completeText ? 'is-delete' : theme]" @click="close">
                        {{ submitText ? submitText : 'Close' }}
                    </button>
                    <button
                        v-if="showComplete"
                        class="button"
                        :class="[theme, { 'is-loading': showLoading }]"
                        @click="submit"
                        :disabled="disabled || showLoading">
                        {{ completeText ? completeText : 'Finish' }}
                    </button>
                    <slot name="extra-button"></slot>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app';
import { db } from '../main.js';
import NProgress from 'nprogress';

export default {
    props: {
        title: String,
        theme: String,
        submitText: String,
        fullWidth: Boolean,
        completeText: String,
        showComplete: Boolean,
        showLoading: Boolean,
        disabled: {
            type: Boolean,
            default: false
        }
    },

    computed: {},

    data: function () {
        return {
            showModal: true,
            isFullWidth: this.fullWidth ? this.fullWidth : false
        };
    },

    methods: {
        close() {
            this.showModal = false;
            let result = {
                answer: 'Modal closed',
                modal: false
            };
            this.$emit('closed', result);
        },
        submit() {
            // this.showModal = false;
            let result = {
                answer: 'Action submitted',
                modal: false
            };
            this.$emit('submit', result);
        }
    }
};
</script>

<style lang="scss" scoped>
.modal {
    z-index: 9999;
    .modal-card {
        background: #fff;
        border-radius: 10px;
        &.is-fullwidth {
            max-width: none;
            width: 90%;
            height: 80%;
            height: 80vh;
        }
    }
}
</style>
